<template>
    <v-dialog
        :persistent="persistent"
        content-class="z-index"
        v-model="dStatus"
        :width="width"
        class="overflow-x ffff000"
        :contentClass="contentClass"
    >
        <v-card>
            <component
                :is="dynamicComponent"
                @persistentStatus="changePersistentStatus "
                :status="status"
                :onClose="onClose"
                :showLoader="showLoader"
                :data="data"
				:onCustomizeClick="onCustomizeClick"
                :success="success"
                :failure="failure"
            ></component>
        </v-card>
    </v-dialog>
</template>
<script>
import vuex from "vuex";

export default {
    props: ["onClose", "component", "status", "width", "contentClass","data","showLoader","onCustomizeClick","success","failure"],
    mounted() {
        if (this.data && this.data.persistent) {
            this.persistent = this.data.persistent;
        }
        this.dStatus = this.status;
    },
    methods: {
        changePersistentStatus(status) {
            this.persistent = status;
        },
    },
    watch: {
        status(val) {
            this.persistent = this.data && this.data.persistent ? this.data.persistent : false;
            this.dStatus = val;
            if(val)
            {
                this.renderMath();
            }
            this.onClose({ status: val, fromAlertBox: true});
        },
        dStatus(val) {
            if(val)
            {
                this.renderMath();
            }
            this.onClose({ status: val, fromAlertBox: true});
        },
        component(val) {
            this.element = val;
        }
    },
    data() {
        return {
            element: this.component,
            persistent: false,
            dStatus: false
        };
    },
    computed: {
        dynamicComponent() {
          this.element = this.element;
          if(this.element){
              return () => import(`@/${this.element}.vue`);
          }
}
    }
};
</script>